import { API_URL } from "@/constants";
import Request from "@/services/api/Request";

export const request = new Request("banners");

export const routes = {
  banners: `${API_URL}/banners/random`
};

export default {
  fetch(params = {}) {
    return this.banners(params);
  },
  banners() {
    return request.get(routes.banners);
  }
};
